import { axiosHelper } from 'Services/AxiosHelper';
import { OnFastLoginModel } from 'Models';
import { onFastLoginBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnFastLogin';

const onFastLogin = async (params: onFastLoginBodyData): Promise<OnFastLoginModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onFastLogin;
